import React, {
  useMemo,
} from 'react';
import {
  ToDoStatus,
} from 'types/toDo';
import {
  useUpdateToDoHandler,
} from 'pages/Dashboard/pages/Todos/hooks';
import StatusSelect from 'pages/Dashboard/pages/Todos/components/StatusSelect';

type Props = {
  toDoId: number;
  dueDate?: string | null;
  isAbandoned?: boolean;
  value: ToDoStatus | undefined;
  options: ToDoStatus[];
  className?: string;
};

export default function ApplicableStatusSelect({
  toDoId,
  dueDate,
  isAbandoned = false,
  value,
  options,
  className,
}: Props) {
  const {
    isLoading: isUpdating,
    asyncHandler: updateToDo,
  } = useUpdateToDoHandler({
    successMessage: 'To-do was updated.',
  });

  const disabled = useMemo(
    () => (options.length === 0 || isUpdating || isAbandoned),
    [options, isUpdating, isAbandoned],
  );

  const handleChange = async ({ transitionName }: ToDoStatus) => {
    await updateToDo({ toDoId, transitionName, dueDate: dueDate ?? null });
  };

  return (
    <StatusSelect
      className={`!text-center ${className}`}
      selectClassName="w-30 !p-0 !m-0"
      muiSelectClassName="!min-h-none !py-1"
      value={value}
      disabled={disabled}
      options={options}
      isLoading={isUpdating}
      loadingText="Updating..."
      onChange={handleChange}
    />
  );
}
